<template>
    <div>
        <div class="upload-index">
            <el-dialog draggable v-model="dialogUPShow" :close-on-click-modal="false" class="form-dialog" :fullscreen="dialogFullscreen" width="1200px">
                <div :class="dialogFullscreen ? 'quanping' : 'no-quanping'">
                    <div class="flex toolbar-btn-action">
                        <div class="btn-box">
                            <el-button @click="topButUpload"><ui-icon type="upload" /> 上传</el-button>
                            <el-button @click="topButAddDir"><ui-icon type="folder-fill" /> 编辑文件夹</el-button>
                            <el-button v-if="dialogFullscreen" @click="topFullscreen"><ui-icon type="quxiaoquanping" /> 收起</el-button>
                            <el-button v-else @click="topFullscreen"> <ui-icon type="quanping" /> 全屏</el-button>
                            <el-button v-if="isChecked" @click="topButUse"> <ui-icon type="collection" /> 选用</el-button>
                        </div>
                    </div>
                    <el-row class="tac">
                        <el-col :span="6">
                            <div class="nav-box">
                                <el-menu default-active="all" class="el-menu-vertical-demo" @select="menuChecked">
                                    <el-menu-item index="all">全部</el-menu-item>
                                    <el-menu-item index="0">未分类</el-menu-item>
                                    <template v-for="(item, index) in menus" :key="index">
                                        <template v-if="item.child">
                                            <el-sub-menu :index="index.toString()">
                                                <template #title>
                                                    <ui-icon v-if="item.icon" :type="item.icon" class="el-menu-top-icon" />
                                                    <span>{{ item.title }}</span>
                                                </template>
                                                <el-menu-item v-for="(sub_item, sub_index) in item.child" :key="sub_index" :index="sub_item.id.toString()">
                                                    <ui-icon v-if="sub_item.icon" :type="sub_item.icon" class="el-menu-top-icon" />
                                                    <template #title>{{ sub_item.title }}</template>
                                                </el-menu-item>
                                            </el-sub-menu>
                                        </template>
                                        <template v-else>
                                            <el-menu-item :key="index" :index="item.id.toString()">
                                                <ui-icon v-if="item.icon" :type="item.icon" class="el-menu-top-icon" />
                                                <template #title>{{ item.title }}</template>
                                            </el-menu-item>
                                        </template>
                                    </template>
                                </el-menu>
                            </div>
                        </el-col>
                        <el-col :span="18">
                            <div class="file-box">
                                <div class="file-list">
                                    <div v-for="(item, index) in dataList" :key="index" class="list-item" :class="item.is_checked ? 'checked' : ''" @click="checkedFileNode(index)">
                                        <div class="image-preview">
                                            <el-image v-if="item.is_image" lazy style="width: 190px; height: 190px" :src="getImgUrl(item.image_thumb)" :preview-src-list="previewList" :initial-index="index" fit="scale-down" />
                                            <template v-else>
                                                <ui-icon v-if="item.ext === 'xlsx'" size="200" type="xlsx" />
                                                <ui-icon v-else size="200" type="manage-order" />
                                            </template>
                                        </div>
                                        <div class="info">
                                            <div class="name">{{ item.name }}</div>
                                            <div class="time">{{ item.create_time }}</div>
                                            <div class="byt">{{ item.size_byte }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="pagination-box">
                                    <el-pagination small background :page-sizes="[10, 15, 20, 30, 50, 100]" :page-size="dataPage.per_page" layout="prev, pager, next,  total, sizes, jumper" :total="dataPage.total" @update:pageSize="PageSizeChange" @update:currentPage="toPage" />
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>
            <div v-if="!isUeditor" class="upload-box">
                <template v-if="dir === 'images'">
                    <div class="upload-image">
                        <div v-for="(item, index) in checkedFilesShow" :key="index" class="upload-image-item">
                            <el-image lazy style="width: 115px; height: 115px" :preview-src-list="checkedPreviewList" :initial-index="index" :src="getImgUrl(item.path)" fit="scale-down" />
                            <ui-icon type="reeor-fill" size="25" class="close-icon" @click="delFile(index)" />
                        </div>
                    </div>
                </template>
                <template v-else-if="dir === 'files'">
                    <div class="upload-file">
                        <div v-for="(item, index) in checkedFilesShow" :key="index" class="upload-file-item">
                            <a :href="getImgUrl(item.path)" target="_blank"> {{ item.path }} </a>
                            <ui-icon type="reeor-fill" size="25" class="close-icon" @click="delFile(index)" />
                        </div>
                    </div>
                </template>
                <el-button :class="`up-button-${isUeditor ? 'hide' : 'show'}`" type="primary" @click="upButton">{{ button }}</el-button>
            </div>
        </div>
        <dirs @update:getDirList="getDirList" />
        <upload :cid="cid" :is-auth="isAuth" :module="module" :dir="dir" @update:getDataList="getDataList" />
    </div>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, inject, reactive, toRaw, provide } from 'vue'
    import { ElMessage, ElMessageBox } from 'element-plus'
    import Api from '@/config/api'
    import Dirs from './dir'
    import Upload from './upload'
    import Utils from '@/utils/util'

    export default defineComponent({
        components: {
            Dirs,
            Upload
        },
        props: {
            isUeditor: {
                type: Boolean,
                default: false
            },
            button: {
                type: String,
                default: ''
            },
            isMultiple: {
                type: Boolean,
                default: false
            },
            checkedData: {
                type: String,
                default: ''
            },
            modelValue: {
                type: [Number, String],
                default: ''
            },
            isAuth: {
                type: Boolean,
                default: false
            },
            dir: {
                type: String,
                default: ''
            },
            module: {
                type: String,
                default: ''
            }
        },
        setup(props, context) {
            const getImgUrl = Utils.getImgUrl
            const { proxy } = getCurrentInstance()
            const dialogUPShow = ref(false)
            const dialogDirShow = ref(false)
            const dialogFullscreen = ref(false)
            const dialogUpload = ref(false)
            const isChecked = ref(false)
            const menus = ref()
            const map = reactive([])
            const checkedFiles = ref([])
            const checkedFilesMap = ref([])
            const checkedFilesShow = ref([])
            const cid = ref('all')
            const checkedPreviewList = ref([])
            if (props.checkedData) {
                let files = []
                let ids = []
                if (props.checkedData.indexOf(',') !== -1) {
                    files = props.checkedData.split(',')
                    ids = props.modelValue.split(',')
                } else {
                    files.push(props.checkedData)
                    ids.push(props.modelValue)
                }

                let is_image = 0
                if (props.dir === 'images') is_image = 1
                files.forEach((item, index) => {
                    checkedFilesMap.value.push(parseInt(ids[index]))
                    let f = {
                        id: parseInt(ids[index]),
                        is_checked: true,
                        path: item,
                        is_image: is_image
                    }
                    checkedFiles.value.push(f)
                    checkedFilesShow.value.push(f)
                })
                let preview = []
                checkedFiles.value.forEach((it) => {
                    preview.push(getImgUrl(it.path))
                })
                checkedPreviewList.value = preview
                if (checkedFilesMap.value.length > 0) {
                    isChecked.value = true
                } else {
                    isChecked.value = false
                }
            }
            if (props.modelValue) {
                map.default = props.modelValue
            }
            const getDirList = () => {
                proxy.jiu.request(Api.AdminAttachmentDirList).then((res, rej) => {
                    menus.value = res.data
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }

            const topButAddDir = () => {
                dialogDirShow.value = true
            }
            const topButUpload = () => {
                dialogUpload.value = true
            }
            const topFullscreen = () => {
                dialogFullscreen.value = !dialogFullscreen.value
            }
            const topButUse = () => {
                let list = []
                let idlist = []
                let preview = []
                let plist = []
                checkedFiles.value.forEach((item) => {
                    list.push(item.path)
                    idlist.push(item.id)
                    preview.push(getImgUrl(item.path))
                    plist.push(item)
                })
                checkedPreviewList.value = preview
                checkedFilesShow.value = plist
                context.emit('update:modelValue', idlist.join(','))
                context.emit('update:checkedData', list.join(','))
                context.emit('update:checkedList', checkedFiles.value)
                dialogUPShow.value = false
            }

            const dataList = ref([])
            const dataPage = ref([])
            const previewList = ref([])
            const getDataList = () => {
                if (props.isUeditor) {
                    checkedFilesMap.value = []
                    checkedFiles.value = []
                }
                map.list_rows = 10
                proxy.jiu.request(Api.AdminAttachmentList, map).then((res, rej) => {
                    let data = res.data
                    dataList.value = data.data_list
                    dataPage.value = data.pages
                    let list = []
                    dataList.value.forEach((item) => {
                        if (item.is_image) {
                            list.push(getImgUrl(item.path))
                        }
                        checkedFiles.value.forEach((it) => {
                            if (item.id === it.id) {
                                item.is_checked = true
                            }
                        })
                    })
                    previewList.value = list
                }).catch((error) => {
                    proxy.jiu.showError(error)
                })
            }

            const checkedFileNode = (e) => {
                // 点击图片上传按钮时不可以选择非图片文件，反之可以
                if (props.dir === 'images' && !dataList.value[e].is_image) {
                    return false
                }
                if (!props.isMultiple) {
                    dataList.value.forEach((item) => {
                        item.is_checked = false
                    })
                    checkedFilesMap.value = []
                    checkedFiles.value = []
                    checkedFilesMap.value.push(dataList.value[e].id)
                    checkedFiles.value.push(dataList.value[e])
                } else {
                    let index = checkedFilesMap.value.indexOf(dataList.value[e].id)
                    if (index > -1) {
                        checkedFilesMap.value.splice(index, 1)
                        checkedFiles.value.splice(index, 1)
                    } else {
                        checkedFilesMap.value.push(dataList.value[e].id)
                        checkedFiles.value.push(dataList.value[e])
                    }
                }
                dataList.value[e].is_checked = !dataList.value[e].is_checked

                if (checkedFilesMap.value.length > 0) {
                    isChecked.value = true
                } else {
                    isChecked.value = false
                }
            }
            const upButton = () => {
                getDirList()
                getDataList()
                dialogUPShow.value = true
            }
            const toPage = (e) => {
                map.page = e
                getDataList()
            }
            const PageSizeChange = (e) => {
                map.page = 1
                map.list_rows = e
                getDataList()
            }

            const menuChecked = (e) => {
                map.page = 1
                map.cid = e
                cid.value = parseInt(e)
                getDataList()
            }
            const delFile = (index) => {
                checkedFilesMap.value.splice(index, 1)
                checkedFiles.value.splice(index, 1)
                if (checkedFilesMap.value.length > 0) {
                    isChecked.value = true
                } else {
                    isChecked.value = false
                }
                let list = []
                let preview = []
                let paths = []
                let plist = []
                dataList.value.forEach((item) => {
                    if (item.is_image) {
                        list.push(getImgUrl(item.path))
                        preview.push(getImgUrl(item.path))
                    }
                    checkedFiles.value.forEach((it) => {
                        if (item.id === it.id) {
                            item.is_checked = true
                        }
                    })
                })
                checkedFiles.value.forEach((it) => {
                    plist.push(it)
                    paths.push(it.path)
                })
                checkedPreviewList.value = preview
                previewList.value = list
                checkedFilesShow.value = plist
                context.emit('update:modelValue', checkedFilesMap.value.join(','))
                context.emit('update:checkedData', paths.join(','))
                context.emit('update:checkedList', checkedFiles.value)
            }
            provide('menus', menus)
            provide('dialogUpload', dialogUpload)
            provide('dialogDirShow', dialogDirShow)
            return {
                dialogUPShow,
                dialogDirShow,
                dialogFullscreen,
                dialogUpload,
                isChecked,

                menus,
                dataList,
                dataPage,
                previewList,
                checkedPreviewList,
                checkedFiles,
                checkedFilesShow,

                topFullscreen,
                topButUpload,
                topButAddDir,
                topButUse,
                getDirList,
                getDataList,
                toPage,
                PageSizeChange,
                getImgUrl,
                checkedFileNode,
                upButton,
                delFile,
                menuChecked,
                cid
            }
        }
    })
</script>

<style>
    .upload-index .el-dialog__header{
        padding: 0;
    }
    .upload-index .el-dialog__body{
        padding: 0;
    }
    .upload-index .toolbar-btn-action{
        padding: 10px;
        background-color: #f7f8f9;
    }
    .upload-index .nav-box{
        overflow: scroll;
        background-color: #f7f8f9;
    }
    .upload-index .file-box{
        padding: 15px;
    }
    .upload-index .file-list{
        display: flex;
        flex-wrap: wrap;
        overflow: scroll;
    }
    .upload-index .list-item{
        width: 190px;
        height: 317px;
        margin: 10px;
        margin-bottom: 20px;
        background-color: #f7f8f9;
        border: 3px solid #ffffff;
    }
    .image-preview{
        overflow: hidden;
    }
    .upload-index .list-item .info{
        padding: 10px;
    }
    .upload-index .list-item .name{
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
    }

    .upload-index .no-quanping .nav-box{
        height: 600px;
    }
    .upload-index .no-quanping .file-list{
        height: 500px;
    }
    .upload-index .quanping .nav-box{
        height: calc(100vh - 55px);;
    }
    .upload-index .quanping .file-list{
        height: calc(100vh - 160px);
    }
    .upload-index .list-item.checked{
        border: 3px solid #1ed2e9;
    }
    .upload-image{
        display: flex;
        flex-wrap: wrap;
    }
    .upload-image .upload-image-item{
        border: 1px solid #e7ebeb;
        width: 115px;
        margin-right: 10px;
        margin-bottom: 10px;
        display: flex;
        position: relative;
    }
    .close-icon{
        position: absolute;
        top: -10px;
        right: -10px;
        color: #c7254e;
        cursor: pointer;
    }

    .upload-file .upload-file-item{
        border: 1px solid #e7ebeb;
        text-overflow:ellipsis;
        white-space:nowrap;
        padding: 5px 10px;
        position: relative;
        margin-bottom: 5px;
    }
    .up-button-hide{
        display: none;
    }
</style>
